import { render, staticRenderFns } from "./StreamInfo.vue?vue&type=template&id=4fbcbdba&scoped=true&"
import script from "./StreamInfo.vue?vue&type=script&lang=js&"
export * from "./StreamInfo.vue?vue&type=script&lang=js&"
import style0 from "./StreamInfo.vue?vue&type=style&index=0&id=4fbcbdba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbcbdba",
  null
  
)

export default component.exports